import React from 'react'
import { hot } from 'react-hot-loader'
import { Router, Head } from 'react-static'
import styled, { ThemeProvider } from 'styled-components'

import { theme } from './theme'
import Routes from './containers/Routes'

import './styles/vendor/normalize.css'
import './styles/vendor/bulma.css'
import './styles/admin.css'
import './styles/vendor/quill-snow.css'
import './styles/index.css'

const Wrapper = styled.div`
  background-color: ${theme.main.bg};
  position: relative;
`

const App = () => (
  <React.Fragment>
    <Router>
      <ThemeProvider theme={theme}>
        <Wrapper>
          <Head defaultTitle="Bagnall Hill Recording Studio" titleTemplate="%s - Bagnall Hill Recording Studio" />
          <Routes />
        </Wrapper>
      </ThemeProvider>
    </Router>
  </React.Fragment>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js